import { Component, inject, OnInit, Signal } from '@angular/core';
import { HeaderPopupBase } from './header-popup-base';
import { Store } from '@ngrx/store';
import { debounceTime, Subject } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BreakpointEnum } from 'src/app/shared/enums/pixel-breakpoints';
import { SidebarService } from 'src/app/shared/services/sidebar/sidebar.service';

@Component({
  template: '',
  standalone: true,
  imports: []
})
export abstract class HeaderPopupListBase<T> extends HeaderPopupBase implements OnInit {
  public abstract data: Signal<T[]>;
  public abstract count: Signal<number>;
  public abstract loading: Signal<boolean>;

  public margin = { horizontal: -25, vertical: 25 };
  public searchTerm = new Subject<string>();
  protected store$ = inject(Store);

  public ngOnInit(): void {
    this.searchTerm.pipe(
      takeUntilDestroyed(this.destroyRef),
      debounceTime(300)
    ).subscribe({
      next: (search) => this.search(search)
    });
  }

  public abstract open(item: T): void;

  public abstract refresh(): void;

  protected abstract search(searchTerm: string): void;

  public override togglePopup(value?: boolean): void {
    this.refresh();
    super.togglePopup(value);
  }
}